import React, { useCallback, useMemo }from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import EventIcon  from '@process-advisor/assets/eventIcon.png'
import ExportIcon  from '@process-advisor/assets/export.png'
import CSVIcon  from '@process-advisor/assets/CSVIcon.png'
import ExcelIcon  from '@process-advisor/assets/XLSIcon.png'
import TaskLifecycleIcon  from '@process-advisor/assets/taskLifecycleIcon.png'

const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 100%;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    type: string,
    height: string;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    type,
    height,
}) => {
    const onGridReady = (params) => {
        params.api.applyColumnState({
            state: [{ colId: 'tasks', sort: 'desc' }],
        });
    };
        
    const taskTable = apiProvider.getTaskTable();
    var urlHost = window.location.protocol + '//' + window.location.host
    if (urlHost == 'http://localhost:8080') { urlHost = 'https://metricus.service-now.com' } 
    
    const onRowClicked = (params) => {
        apiProvider.setTaskDetailSelectedData({ selection: params.api.getSelectedRows() });
    };

    const onFirstDataRendered  = (params) => {
        const allColumnIds = [];
        params.api.getAllGridColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        params.api.autoSizeAllColumns();
    };

    const enableCharts = true;
    const enableRangeSelection = true;
    const getRowHeight = () => 25;

    const ContextMenuItems = useCallback((params) => {
        var result = []
        if (type === 'event-detail') {
            result = [
            {
                // custom item
                name: apiProvider.getEntityUpper() + ' LifeCycle',
                action: function () {
                    apiProvider.setTaskID({taskID: params.node.data.k })
                    apiProvider.setTasksVisualizationSource({source: 'detail'})
                    apiProvider.tasksVisualization()
                    apiProvider.taskLifecycle({})
                },
                icon: '<img src="' + TaskLifecycleIcon + '" />',
            },
            'separator',
            'copy',
            {
                name: 'Export',
                icon: '<img src="' + ExportIcon + '" />',
                subMenu: [
                    {
                        name: 'CSV Export (all)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'CSV Export (selected)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'XLS Export (all)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                    {
                        name: 'XLS Export (selected)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                ],
            },        
    
            ];} 
        if (type === 'task-detail') {
            result = [
            {
                name: 'Events',
                action: function () {
                    apiProvider.setTaskID({taskID: params.node.data.k })
                    apiProvider.eventDetail({})
                },
                icon: '<img src="' + EventIcon + '" />',
            },
            {
                // custom item
                name: apiProvider.getEntityUpper() + ' LifeCycle',
                action: function () {
                    apiProvider.generateTasksFilteredArray({variantPaneVariants: false, type: 'task_detail', variant: 0,  activity: 0, from: 0, to: 0, task: params.node.data.k})
                    apiProvider.setTasksVisualizationSource({source: 'detail'})
                    apiProvider.tasksVisualization()
                    apiProvider.taskLifecycle({})
                },
                icon: '<img src="' + TaskLifecycleIcon + '" />',
            },
            'separator',
            'copy',

            {
            name: 'Export',
            icon: '<img src="' + ExportIcon + '" />',
            subMenu: [
                {
                    name: 'CSV Export (all)',
                    action: () => params.api.exportDataAsCsv(
                        {onlySelected: false}
                      ),
                    icon: '<img src="' + CSVIcon + '" />',
                },
                {
                    name: 'CSV Export (selected)',
                    action: () => params.api.exportDataAsCsv(
                        {onlySelected: true}
                      ),
                    icon: '<img src="' + CSVIcon + '" />',
                },
                {
                    name: 'XLS Export (all)',
                    action: () => params.api.exportDataAsExcel(
                        {onlySelected: false}
                      ),
                    icon: '<img src="' + ExcelIcon + '" />',
                },
                {
                    name: 'XLS Export (selected)',
                    action: () => params.api.exportDataAsExcel(
                        {onlySelected: true}
                      ),
                    icon: '<img src="' + ExcelIcon + '" />',
                },

            ],
        },        


        ];}      
        if (type != 'event-detail' && type != 'task-detail') {
            result = [
                'export',     
            ]   
        }

        return result;
      }, []);    

      return (
        <Wrapper height={height}>
            <div
                
                style={{
                    height: '100%',
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    rowSelection="multiple"
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    getRowHeight={getRowHeight}
                    getContextMenuItems={ContextMenuItems}
                    onRowClicked={onRowClicked}
                    overlayNoRowsTemplate={'Please select a source for the detail data'}
                    columnDefs={columns}
                    headerHeight={40}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                        wrapText: true,
                        autoHeight: true,
//                        enableRowGroup: true
                    }}
                    rowData={rows}
//                    groupDisplayType={'singleColumn'}
//                    groupHideOpenParents={false}
//                    rowGroupPanelShow={'always'}  
//                    suppressAggFuncInHeader={true}

                    sideBar={
                        {
                            toolPanels: [
                                {
                                    id: 'columns',
                                    labelDefault: 'Columns',
                                    labelKey: 'columns',
                                    iconKey: 'columns',
                                    toolPanel: 'agColumnsToolPanel',
                                    toolPanelParams: {
                                        suppressRowGroups: true,
                                        suppressValues: true,
                                        suppressPivotMode: true, 
                                    }
                      
                                },
                                {
                                    id: 'filters',
                                    labelDefault: 'Filters',
                                    labelKey: 'filters',
                                    iconKey: 'filter',
                                    toolPanel: 'agFiltersToolPanel',
                                },
                            ],
                            hiddenByDefault: false,
                            defaultToolPanel: '',
                        }
                    }
                    enableCharts={enableCharts}
                    chartThemes={[
                        'ag-solar',
                        'ag-pastel',
                        'ag-material-dark',
                        'ag-vivid-dark',
                    ]}
                    enableRangeSelection={enableRangeSelection}
                />
            </div>
        </Wrapper>
    );
};
